export default {
  submenu: 'Submenu:',
  content: 'Content',
  overview: 'Overview',
  longTermSupport: 'Long Term Support',
  skillsAndTalents: 'Skills and Talents',
  yourMap: 'Your Map',
  motivationAndEmotionalIntelligence: 'Motivation and Emotional Intelligence',
  alliancesCompromisesAndResources: 'Alliances, Compromises and Resources',
  skillsToStartABusiness: 'Skills to Start a Business',
  accountingAndFinance: 'Accounting & Finance',
  settingUpYourOwnBusiness: 'Setting up Your Own Business',
  accountingBasics: 'Accounting Basics',
  openingABankAccount: 'Opening a Bank Account',
  businessPlanBasicInformation: 'Business Plan, Basic Information',
  taxes: 'Taxes',
  legalFormsOfEmployment: 'Legal Forms of Employment',
  marketingAndSales: 'Marketing & Sales',
  whatAreMyProducts: 'What are My Products?',
  whoAreMyClients: 'Who are My Clients?',
  communication: 'Communication',
  positioning: 'Positioning',
  sales: 'Sales',
  uniqueSellingPoints: 'Unique Selling Points',
  publicRelations: 'Public Relations',
  introduction: 'Introduction',
  strategy: 'Strategy',
  messagesAndTools: 'Messages and Tools',
  digitalPRAndSMRevolution: 'Digital PR and SM Revolution',
  it: 'IT',
  cloudVSOnPremises: 'Cloud vs. On-Premises',
  email: 'Email',
  onlineMarketing: 'Online Marketing',
  webshop: 'Webshop',
  website: 'Website'
}



// WEBPACK FOOTER //
// ./src/i18n/contentnav/en.js